export const rubyErrorMessage = {
  sender: "ruby",
  message:
    "We are unable to accept any new users at this time. Please try again later or check back when there is availability. Thank you for your understanding.",
};
